'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import GlobalHelper from '../../Common/Helpers/GlobalHelper';
import {
    ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH
    , NOT_FOUND_CLIENTE_ADICIONAL
    , RELOAD_BUSQUEDA_CLIENTE_TARJETAS
    , SET_DATA_CLIENTE
    , SET_CLAIMS
} from '../../Screens/ClientSearch/actions/Actions'
import { GET_SCREEN_DATA_CLIENTE } from '../../Screens/Cliente/actions/Actions';
import {
    ACTUALIZAR_ESTADO_GLOBAL_VISTA_CLIENTE,
    ACTUALIZAR_ESTADO_GLOBAL_DATOS_SOLICITUD_VISTA_CLIENTE,
    SET_EDICION_SOLICITUD_ID,
    RESET_STATE_VISTA_CLIENTE
} from '../../Screens/VistaCliente/actions/VistaClienteActions';
import { ACTUALIZAR_ESTADO_GLOBAL_ADMINISTRADORA } from '../../Screens/NuevaSolicitudAdministradora/actions/NuevaSolicitudAdministradoraActions';
import { ACTUALIZAR_ESTADO_GLOBAL_TIPOEMPRESA, ELIMINAR_FUTURO_FROM_TIPO_EMPRESA, RESET_SELECCIONES_CUENTA } from '../../Screens/NuevaSolicitudTipoEmpresa/actions/NuevaSolicitudTipoEmpresaActions';
import { ACTUALIZAR_ESTADO_GLOBAL_EMPRESA, ACTUALIZAR_ESTADO_DISTRIBUCION_EMPRESA, ELIMINAR_FUTURO_FROM_EMPRESA, EMPRESA_SELECCIONADA } from '../../Screens/NuevaSolicitudEmpresa/actions/NuevaSolicitudEmpresaActions';
import { ACTUALIZAR_ESTADO_GLOBAL_CUENTA, ACTUALIZAR_ESTADO_DISTRIBUCION_CUENTA, SAVE_SOLICITUD_CUENTA_SELECCION, LOAD_MODIFICACION_SOLICITUD_TARJETAS, VOLVER_A_SOLICITUD_NSC, CARGAR_ADICIONALES_MODIFICACION, CARGAR_CLIENTE_PARA_TARJETA, CONFIRMAR_CLIENTE_PARA_TARJETA, CARGAR_DATOS_MODIFICACION_TARJETAS } from '../../Screens/NuevaSolicitudCuenta/actions/NuevaSolicitudCuentaActions';
import { ACTUALIZAR_ESTADO_GLOBAL_TARJETA, ACTUALIZAR_ESTADO_DISTRIBUCION_TARJETA } from '../../Screens/NuevaSolicitudTarjeta/actions/NuevaSolicitudTarjetaActions';
import { GUARDAR_DISTRIBUCION_LIMITES } from '../../Screens/DistribucionLimites/actions/DistribucionLimitesActions';
import { ACTUALIZAR_ESTADO_GLOBAL_NUEVA_CUENTA, ACTUALIZAR_ESTADO_GLOBAL_CUENTA_SELECCIONADA, ELIMINAR_FUTURO_FROM_CUENTA } from '../../Screens/Cuenta/actions/Actions';
import { GUARDAR_SOLICITUD_CUENTA_ADICIONAL, ELIMINAR_CLIENTE_ADICIONAL, VOLVER_A_SOLICITUD, CONFIRMAR_CLIENTE_PARA_TARJETA_ADICIONAL, ELIMINAR_CLIENTE_ADICIONAL_TARJETAS } from '../../Screens/NuevaSolicitudAdicional/actions/NuevaSolicitudAdicionalActions'

import { SET_STATE_FROM_VIGENTE, SET_BORRADOR_ID, ACTUALIZAR_DATOS_INICIO_NUEVA_SOLICITUD, RESET_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE, ADICIONAL_CUENTA_EXISTENTE, CLEAN_SOLICITUD_CUENTA, GET_EMPRESAS, ROUTE_TO_CUENTA_CLIENTE, SELECCIONAR_COMPONENTE, DAR_DE_BAJA_CUENTA } from '../../Screens/VistaCliente/actions/VistaClienteActions';

//Delivery...
import {
    WEBSERVICE_RESULT,
    CARGAR_TARJETAS_BY_CUENTA,
    BORRAR_SOLICITUD_PENDIENTE_CUENTAS,
    OBTENER_DOMICILIOS_SELECCIONAR_CUENTA,
    SET_CUENTA_DELIVERY
} from '../../Screens/SeleccionCuentas/actions/Actions';

import {
    ADD_TARJETA_NUEVA_SOLICITUD,
    REMOVE_TARJETA_NUEVA_SOLICITUD
} from '../../Screens/NuevaSolicitud/actions/Actions';
let date = new Date();
import {
    GET_INITIAL_DATA_TARJETAS_SUCCESS
} from '../../Screens/Tarjetas/actions/tarjetas';

import {
    RESET_PROP_TARJETAS
} from '../../Screens/DatosCuenta/actions/Actions';
import { debug } from 'util';
/*
IMPORTANTE...
El objetivo del presente store es contener un estado comun entre las paginas que constituyan el procedo de "Nueva Solicitud".
Para ello se debera almacenar aqui todos aquellos datos que formaran parte del flujo.
*/

/**
 * Estado inicial.
 */
const initialState = {
    //datos del cliente...
    id: 0,
    solicitudInitialState: undefined,
    cliente: undefined,
    clienteResultadoBusqueda: undefined,
    empresas: undefined,
    cuentas: undefined,
    tarjetas: undefined,
    novedadesEmpresas: undefined,
    novedadesCuentas: undefined,
    novedadesTarjetas: undefined,
    darDeBajaCuenta: null,
    seleccionDistribucionLimite: 0, //Inicializa en 0 para que la pantalla VistaCliente seleccione Empresa por default

    //Items que selecciona en la nueva solicitud...
    //TODO: Sacarlo este mock posteriormente
    administradora: {
        Id: 1,
        Descripcion: 'Visa',
        Codigo: 'V'
    },
    tipoEmpresa: undefined,
    solicitudCuenta: {},
    carteras: undefined,
    SolicitudAdicional: {},
    //ver...
    esModificacion: false,
    estadoSolicitud: undefined,
    borradorId: undefined,

    //DELIVERY...
    dataUsuario: undefined,
    tarjetas: [],
    solicitudes: [],
    consultaCuenta: [],
    cuentasDelivery: undefined,
    domicilios: undefined,
    limites: undefined,
    erroresLink: undefined,
    estadosIbs: undefined,
    sucursalUsuarioId: undefined,
    plasticosSolicitudes: [],
    sucursalesDelivery: undefined,
    //FIN DELIVERY...

    programSelected: false,
    perfiles: 0,
    defaultProducto: null,
    novedadesCampoLimites: undefined,
    Cliente: null,
    componenteVistaCliente: null
};

let resultado;
let empresasTemp;
let cuentasTemp;
let tarjetasTemp;

function tarjetas(state = initialState, action) {
    LogHelper.In(tarjetas.name, state, action);

    switch (action.type) {

        case ADICIONAL_CUENTA_EXISTENTE:
            //EN TARJETAS.SOLICITUDCUENTA SE GUARDAN TODOS LOS DATOS QUE NORMALMENTE SE HABRIAN GUARDADO DESDE NUEVASOLICITUDCUENTA Y NUEVASOLICITUDADICIONAL REQUIERE PARA FUNCIONAR
            //REVISAR PROPIEDADES CUANDO SE GENEREN CUENTAS VERDADERAS EN LA BASE DE DATOS

            let datosSolicitudCuenta = action.result.datosSolicitud.length > 0 ? action.result.datosSolicitud[0] : {};

            let solicitudCuentaObjeto = {
                GET_PRODUCTO_VISA_PRODUCTO_ID: action.result.GET_PRODUCTO_VISA_PRODUCTO_ID && action.result.GET_PRODUCTO_VISA_PRODUCTO_ID[0] && action.result.GET_PRODUCTO_VISA_PRODUCTO_ID[0],
                GET_PRODUCTO_CABAL_PRODUCTO_ID: action.result.GET_PRODUCTO_CABAL_PRODUCTO_ID && action.result.GET_PRODUCTO_CABAL_PRODUCTO_ID[0] && action.result.GET_PRODUCTO_CABAL_PRODUCTO_ID[0],
                productoVisaSeleccionado: action.result.GET_PRODUCTO_VISA_PRODUCTO_ID,
                GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID: action.result.GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID,
                GET_ATLAS_LIMITE_COMPRA: action.result.GET_ATLAS_LIMITE_COMPRA,
                GET_PRODUCTO_DEFAULT_VISA_PRODUCTO: {},
                ProductoVisaSeleccionadoDatosDefault: {},
                GET_ATLAS_PARAMETRO_GENERAL: action.result.GET_ATLAS_PARAMETRO_GENERAL ? action.result.GET_ATLAS_PARAMETRO_GENERAL[0] : {},
                GET_CARTERAS_EMPRESA: action.result.GET_CARTERAS_EMPRESA,
                GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO: action.result.GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO,
                GET_SUCURSAL_CLIENTE_CUENTA: action.result.GET_SUCURSAL_CLIENTE_CUENTA,
                GET_HABILITACION_CAJERO_PRODUCTO: action.result.GET_HABILITACION_CAJERO_PRODUCTO,
                HabilitacionCajeros: action.result.GET_HABILITACION_CAJERO_PRODUCTO,
                GET_ATLAS_MONEDA: action.result.GET_ATLAS_MONEDA,
                cuotasCostoEmisionSeleccionadas: action.result.cuenta.cuotasEmision ? action.result.cuenta.cuotasEmision : null,
                porcentajeCostoEmision: action.result.cuenta.PorcentajeEmision ? action.result.cuenta.PorcentajeEmision : null,
                ATLAS_TIPO_COMUNICACION: action.result.ATLAS_TIPO_COMUNICACION,
                GET_ATLAS_ENTIDAD_BANCARIA: action.result.GET_ATLAS_ENTIDAD_BANCARIA,
                GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID: action.result.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID,
                GET_TARJETA_TIPO_BY_CUENTA_TIPO: action.result.GET_TARJETA_TIPO_BY_CUENTA_TIPO,
                GET_ATLAS_TIPO_CUENTA_BANCARIA: action.result.GET_ATLAS_TIPO_CUENTA_BANCARIA,
                productoId: action.productoId,
                GET_PRODUCTO_CABAL_PRODUCTO_ID: {},
                GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO: {},
                ATLAS_DISTRIBUCION: action.result.GET_CODIGO_DISTRIBUCION,
                cuentasAdicionales: action.result.cuenta.Tarjetas,
                modeloDistribucionId: action.result.cuenta.ModalidadDistribucionLimiteId,
                limiteCompraId: action.result.cuenta.LimiteId,
                limiteCompraTipoLMonto: action.result.cuenta.ModalidadDistribucionLimiteId ? action.result.cuenta.ModalidadDistribucionLimiteId.limite : null,
                limiteCompra: action.result.cuenta.limite,
                porcEmision: action.result.cuenta.PorcentajeEmision,
                cuotasEmision: action.result.cuenta.cuotasEmision,
                cuartaLinea: null,
                codigoDistribucionSeleccionadoId: action.result.cuenta.ModalidadDistribucionLimiteId,
                categoriaCajerosId: action.result.cuenta.categoriaCajerosId,
                carteraId: datosSolicitudCuenta.CarteraId,
                codigoGeograficoId: datosSolicitudCuenta.codigoGeograficoDomicilioParticular,
                codigoPlanta: datosSolicitudCuenta.Planta,
                comCodGeogId: datosSolicitudCuenta.codigoGeograficoDomicilioCorrespondencia,
                codigoPostalDomicilioParticular: datosSolicitudCuenta.codigoPostalDomicilioCorrespondencia,
                comDomicilioSeleccionadoId: datosSolicitudCuenta.DomicilioCorrespondenciaId,
                comEmail: datosSolicitudCuenta.TipoCorrespondenciaId == 2,
                comercializadoraSeleccionadaId: datosSolicitudCuenta.ComercializadoraCanalId,
                cuentaPropiaPorTarjeta: datosSolicitudCuenta.CreaCuentaDescentralizada == true,
                denominacionCuenta: datosSolicitudCuenta.CuentaDenominacion,
                descripcionCuenta: datosSolicitudCuenta.Descripcion,
                domicilioSeleccionadoId: datosSolicitudCuenta.DomicilioParticularId,
                email: datosSolicitudCuenta.Email,
                factorLimiteCompra: datosSolicitudCuenta.FactorLimiteCompraCuotas,
                formaDebitoId: datosSolicitudCuenta.FormaDebitoId,
                formaPagoId: datosSolicitudCuenta.FormaPagoId,
                grupoAfinidadSeleccionadoId: datosSolicitudCuenta.GrupoAfinidadId,
                limiteCompraId: datosSolicitudCuenta.LimiteCompraId,
                limiteCompra: datosSolicitudCuenta.ImporteLimiteCompra,
                limiteFinanciacion: datosSolicitudCuenta.LimiteFinanciacion,
                limitePrestamoId: datosSolicitudCuenta.LineaPrestamoId,
                modalVisibleLimites: false,
                modeloDistribucionId: datosSolicitudCuenta.ModalidadDistribucionLimiteId,
                modeloLiquidacionId: datosSolicitudCuenta.ModeloLiquidacionId,
                monedaSelected: datosSolicitudCuenta.MonedaId,
                pesos: datosSolicitudCuenta.MonedaId == 1,
                preEmisionId: null,
                productoId: datosSolicitudCuenta.ProductoId,
                promotorSeleccionado: datosSolicitudCuenta.PromotorId,
                subTipoCuentaSeleccionadaId: datosSolicitudCuenta.SubtipocuentaId,
                SolicitudId: action.result.SolicitudId,
                SolicitudTipoId: 3
            };


            //SE MAPEAN LOS ADICIONALES TRAIDOS DE BASE DE DATOS Y SE LES ASIGNA UNA PROPIEDAD QUE INDICA QUE NO SE PUEDEN MODIFICAR
            if (action.result.cuenta.Tarjetas && Array.isArray(action.result.cuenta.Tarjetas)) {
                action.result.cuenta.Tarjetas.map(tarjeta => {
                    tarjeta.prohibeModificar = tarjeta.TarjetaCreditoEstadoId == 1 ? false : true;
                    tarjeta.LimiteDeCompra = tarjeta.LimiteDeCompra ? tarjeta.LimiteDeCompra : tarjeta.PorcentajeLimiteCompra;
                    if (tarjeta.TarjetaCreditoEstadoId == 1) {
                        let nombreDenominacion = "";
                        let apellidoDenominacion = "";

                        if (tarjeta.Denominacion && tarjeta.Denominacion.includes('/')) {
                            nombreDenominacion = tarjeta.Denominacion.split('/')[1];
                            apellidoDenominacion = tarjeta.Denominacion.split('/')[0];
                            tarjeta.Nombre = nombreDenominacion
                            tarjeta.Apellido = apellidoDenominacion
                        }
                        //es necesario que los adicionales tengan este objeto que contiene los datos del cliente para su manejo por NuevaSolicitudAdicional y SolicitudManager
                        let ClienteTarjetas = {
                            Apellido: apellidoDenominacion,
                            Nombre: nombreDenominacion,
                            APELLIDO: apellidoDenominacion,
                            Denominacion: tarjeta.Denominacion,
                            ApellidoCompleto: tarjeta.Apellido,
                            CliNum: tarjeta.ClienteBancoNumero,
                            CuentaCliente: "",
                            Cuit: tarjeta.Cuit,
                            IIBBId: tarjeta.TipoIibbId,
                            Id: tarjeta.IdCliente,
                            NOMBRE: nombreDenominacion,
                            NUMERO_DOCUMENTO: tarjeta.NumeroDocumento,
                            Nacionalidad: tarjeta.NacionalidadId,
                            NombreCompleto: tarjeta.Nombre,
                            RAZON_SOCIAL: tarjeta.RazonSocial,
                            TIPO_DOCUMENTO_ID: tarjeta.TipoDocumentoId,
                            esPersonaFisica: tarjeta.FisicaJuridica == "F",
                            estadoCivilId: tarjeta.EstadoCivilId,
                            gananciasId: tarjeta.CategoriaGananciasId,
                            identidadCliente: tarjeta.Nombre + " " + tarjeta.Apellido,
                            ocupacionId: tarjeta.OcupacionId,
                            tipoCliente: tarjeta.FisicaJuridica == "F" ? "Persona Física" : "Persona Jurídica",
                            tipoIva: tarjeta.CategoriaIvaId,
                            nacionalidadVisa: tarjeta.NacionalidadCodigoVisa ? tarjeta.NacionalidadCodigoVisa : null,
                            estadoCivilVisa: tarjeta.EstadoCivilCodigoVisa ? tarjeta.EstadoCivilCodigoVisa : null,
                            ocupacionVisa: tarjeta.OcupacionCodigoVisa ? tarjeta.OcupacionCodigoVisa : null,
                            estadoCivilCabalDoc: tarjeta.EstadoCivilCodigo ? tarjeta.EstadoCivilCodigo : null,
                            ocupacionCabalDoc: tarjeta.ProfesionCodigo ? tarjeta.ProfesionCodigo : null,
                            codigoCabalDoc: tarjeta.DocumentoTipoCodigo ? tarjeta.DocumentoTipoCodigo : null,
                            documentoCodigoVisa: tarjeta.DocumentoTipoCodigoVisa,
                            DatosClientes: {
                                TipoPersona: "F",
                                Sexo: tarjeta.Sexo,
                                FechaNac: tarjeta.FechaNacimiento
                            }
                        };

                        tarjeta.ClienteTarjetas = ClienteTarjetas
                    }
                })
            }

            resultado = {
                ...state,
                solicitudCuenta: solicitudCuentaObjeto,
                esCuentaExistente: true,
                tipoEmpresa: action.result.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA[0],
                administradora: action.result.GET_ADMINISTRADORA[0],
                empresaVisaSeleccionada: action.result.empresa,
                cuentasAdicionales: action.result.cuenta.Tarjetas,
                datosSolicitud: (action.result.datosSolicitud && action.result.datosSolicitud[0]) ? action.result.datosSolicitud[0] : {},
                esModificacion: true //cambiar
            }

            break;
        case GET_EMPRESAS:
            //LA ACTION DE VISTACLIENTE QUE TRAE LOS DATOS DE SOLICITUDES, EMPRESAS Y LIMITES LLENA ESTOS VALORES NECESARIOS PARA NUEVA SOLICITUD EMPRESA
            resultado = {
                ...state,
                empresas: action.data.empresas,
                cuentas: action.data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA.concat(action.data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_OTRAS),
                tarjetas: action.data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES,
                novedadesEmpresas: [],//MOCKEADO HASTA DESARROLLAR NOVEDADES
                clienteResultadoBusqueda: {
                    ...state.clienteResultadoBusqueda,
                    LimitePorCuit: 0, //MOCKEADO HASTA QUE EL WS ENVÍE INFORMACIÓN DE LÍMITES
                    limiteCompraEmpresaOperativa: (Array.isArray(action.data.CONSULTA_SOLICITUD_CUENTA_CLIENTE) && action.data.CONSULTA_SOLICITUD_CUENTA_CLIENTE.length > 0) ? action.data.CONSULTA_SOLICITUD_CUENTA_CLIENTE[0].limiteCompraEmpresaOperativa : 0
                }
            }
            break;

        case SET_STATE_FROM_VIGENTE:

            resultado = action.data;
            break;

        case SET_EDICION_SOLICITUD_ID:

            resultado = {
                ...state,
                id: action.idSolicitud
            };
            break;
        case RELOAD_BUSQUEDA_CLIENTE_TARJETAS:

            resultado = {
                ...state,
                loadingCliente: action.payload
            };
            break;
        case DAR_DE_BAJA_CUENTA:

            resultado = {
                ...state,
                darDeBajaCuenta: action.cuentaTarjetaId
            };
            break;
        case RESET_PROP_TARJETAS:

            resultado = {
                ...state,
                [action.prop]: null
            };
            break;

        case SET_BORRADOR_ID:

            resultado = {
                ...state,
                borradorId: action.borradorId
            };
            break;

        case ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH:

            resultado = {
                ...state,
                clienteResultadoBusqueda: action.cliente,
                cuentas: !action.cliente.Id > 0 ? [] : undefined,
                empresas: !action.cliente.Id > 0 ? [] : undefined

            };
            break;

        case ACTUALIZAR_ESTADO_GLOBAL_VISTA_CLIENTE:

            resultado = {
                ...state,
                cliente: action.cliente,
                novedadesCampoLimites: action.novedadesCampoLimites,
                seleccionDistribucionLimite: 0,
                novedadesEmpresas: action.novedades.novedadesEmpresas,
                novedadesCuentas: action.novedades.novedadesCuentas,
                novedadesTarjetas: action.novedades.novedadesTarjetas
            };
            break;
        case CARGAR_CLIENTE_PARA_TARJETA:

            resultado = {
                ...state,
                clienteTarjeta: action.payload,
                errorWSClienteAdicional: null
            };
            break;
        case NOT_FOUND_CLIENTE_ADICIONAL:
            if (action.errorBusqueda) {
                resultado = {
                    ...state,
                    clienteTarjeta: null,
                    errorWSClienteAdicional: action.errorBusqueda
                };
            } else {
                resultado = {
                    ...state,
                    errorWSClienteAdicional: null
                };
            }

            break;
        case CONFIRMAR_CLIENTE_PARA_TARJETA:

            if (action.payload == true) {
                if (!action.cliente) {
                    resultado = {
                        ...state,
                        clienteTarjeta: {
                            ...state.clienteTarjeta,
                            confirmado: true
                        }
                    };
                    break;
                } else {
                    resultado = {
                        ...state,
                        clienteTarjeta: action.cliente
                    };
                    break;
                }
            } else if (action.payload == false) {
                resultado = {
                    ...state,
                    clienteTarjeta: null
                };
                break
            }
        case CONFIRMAR_CLIENTE_PARA_TARJETA_ADICIONAL: {
            resultado = {
                ...state,
                clienteTarjeta: null
            };
            break
        }

        case ACTUALIZAR_ESTADO_GLOBAL_DATOS_SOLICITUD_VISTA_CLIENTE:

            action.resultado.empresas.forEach(function (empresa) {
                empresa.esNueva = false;
                empresa.seleccionada = false;
                empresa.limiteCompraFormato = GlobalHelper.ConvertirNumeroSinDecimales(empresa.LimiteCompra);
            })

            action.resultado.cuentas.forEach(function (cuenta) {
                cuenta.esNueva = false;
                cuenta.seleccionada = false;
                cuenta.valorFormato = GlobalHelper.ConvertirNumeroSinDecimales(cuenta.Valor);
                cuenta.valorAnterior = cuenta.Valor;
            })

            action.resultado.tarjetas.forEach(function (tarjeta) {
                tarjeta.esNueva = false;
                tarjeta.limiteAnterior = tarjeta.PorcentajeLimiteCompra;
            })

            action.resultado.novedadesEmpresas.forEach(function (novedadEmpresa) {
                novedadEmpresa.limiteCompraFormato = false;
                novedadEmpresa.valorAnteriorFormato = GlobalHelper.ConvertirNumeroSinDecimales(novedadEmpresa.ValorAnterior);
                novedadEmpresa.valorNovedadFormato = GlobalHelper.ConvertirNumeroSinDecimales(novedadEmpresa.ValorNovedad);
            })

            action.resultado.novedadesCuentas.forEach(function (novedadCuenta) {
                novedadCuenta.valorFormato = false;
                novedadCuenta.valorAnteriorFormato = GlobalHelper.ConvertirNumeroSinDecimales(novedadCuenta.ValorAnterior);
                novedadCuenta.valorNovedadFormato = GlobalHelper.ConvertirNumeroSinDecimales(novedadCuenta.ValorNovedad);
            });

            let solicitudInitialState = {
                empresas: action.resultado.empresas,
                cuentas: action.resultado.cuentas,
                tarjetas: action.resultado.tarjetas
            }

            resultado = {
                ...state,
                id: action.resultado.id,
                solicitudInitialState: solicitudInitialState,
                empresas: action.resultado.empresas,
                cuentas: action.resultado.cuentas,
                tarjetas: action.resultado.tarjetas,
                novedadesEmpresas: action.resultado.novedadesEmpresas,
                novedadesCuentas: action.resultado.novedadesCuentas,
                novedadesTarjetas: action.resultado.novedadesTarjetas,
                carteras: action.resultado.carteras
            }
            break;

        case ACTUALIZAR_ESTADO_GLOBAL_ADMINISTRADORA:

            resultado = {
                ...state,
                administradora: action.administradora
            };
            break;

        case ACTUALIZAR_ESTADO_GLOBAL_TIPOEMPRESA:

            resultado = {
                ...state,
                tipoEmpresa: action.tipoEmpresa
            };
            break;

        case SAVE_SOLICITUD_CUENTA_SELECCION:

            switch (action.prop) {
                case "PRODUCTO": {
                    if (state.solicitudCuenta && state.solicitudCuenta.datosGeneralesModificacion == true) {
                        resultado = {
                            ...state,
                            datosGeneralesModificacion: true
                        }
                    } else {
                        resultado = {
                            ...state,
                            solicitudCuenta: {
                                ...state.solicitudCuenta,
                                PRODUCTO: action.value,
                                GET_PRODUCTO_VISA_PRODUCTO_ID: {},
                                GET_PRODUCTO_CABAL_PRODUCTO_ID: {},
                                GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO: {},
                                GET_PRODUCTO_DEFAULT_VISA_PRODUCTO: [],
                                celularSeleccionado: "",
                                codigoGeograficoId: "",
                                codigoPlanta: "",
                                comCodGeogId: "",
                                comDomicilioPostal: false,
                                comEmail: false,
                                cuentaPropiaPorTarjeta: false,
                                cuentaSeleccionada: undefined,
                                cuentasInfo: undefined,
                                denominacionApellido: undefined,
                                denominacionCuenta: "",
                                denominacionNombre: undefined,
                                descripcionCuenta: "",
                                domicilioSeleccionadoId: "",
                                limiteCompra: undefined,
                                topePagoMinimo: undefined,
                                modalVisibleLimites: false,
                                mostrarError: false,
                                novedades: undefined,
                                permisos: undefined,
                                preEmisionId: undefined,
                                telefonoSeleccionado: "",
                                marcaCompartidaSeleccionadaId: undefined,
                                segmentoCarteraSeleccionadoId: undefined,
                                cuotasCostoEmision: undefined,
                                carteraId: undefined,
                                modeloLiquidacionId: undefined,
                                limiteFinanciacion: undefined,
                                categoriaCajerosId: undefined,
                                formaPagoId: undefined,
                                formaDebitoId: undefined,
                                sucursalCuentaPesosId: undefined,
                                cuentaPesosId: undefined,
                                sucursalCuentaDolaresId: undefined,
                                cuentaDolaresId: undefined,
                                cuentaSelected: undefined,
                                modeloDistribucionId: undefined,
                                limiteCompraId: undefined,
                                monedaSelected: undefined,
                                factorLimiteCompra: undefined,
                                limitePrestamoId: undefined,
                                subTipoCuentaSeleccionadaId: undefined,
                                grupoAfinidadSeleccionadoId: undefined,
                                codigoDistribucionSeleccionadoId: undefined,
                                comercializadoraSeleccionadaId: undefined,
                                domicilioPostal: undefined,
                                email: undefined,
                                comDomicilioSeleccionadoId: undefined,
                                comTipo: undefined,
                                TarjetaTipoId: undefined,
                                cuartaLinea: undefined,
                                altaPosDatadaId: undefined,
                                retencionTarjetaId: undefined,
                                grabadoCuartaLinea: undefined,
                                CLCC: undefined,
                                promotorSeleccionado: undefined,
                                productoId: undefined,
                                denominacionCuartaLinea: undefined,
                                denominacion1: undefined,
                                denominacion2: undefined
                            }
                        }
                    }
                    break;
                }
                case "porcEmision": {
                    resultado = {
                        ...state,
                        solicitudCuenta: {
                            ...state.solicitudCuenta,
                            porcentajeCostoEmision: action.value
                        }
                    }
                    break;
                }
                case "cuotasEmision": {
                    resultado = {
                        ...state,
                        solicitudCuenta: {
                            ...state.solicitudCuenta,
                            cuotasCostoEmisionSeleccionadas: action.value
                        }
                    }
                    break;
                }
                case "cleanSolicitudCuenta": {
                    resultado = {
                        ...state,
                        solicitudCuenta: null
                    }

                }
                case "datosProductoSeleccionado":
                    resultado = {
                        ...state,
                        tipoEmpresa: state.esModificacion ? action.value.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA[0] : state.tipoEmpresa,
                        solicitudCuenta: {
                            ...state.solicitudCuenta,
                            productoVisaSeleccionado: action.value.GET_PRODUCTO_VISA_PRODUCTO_ID,
                            ProductoVisaSeleccionadoDatosDefault: action.value.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO,
                            ProductoCabalSeleccionado: action.value.GET_PRODUCTO_CABAL_PRODUCTO_ID && action.value.GET_PRODUCTO_CABAL_PRODUCTO_ID,
                            GET_PRODUCTO_CABAL_PRODUCTO_ID: action.value.GET_PRODUCTO_CABAL_PRODUCTO_ID && action.value.GET_PRODUCTO_CABAL_PRODUCTO_ID,
                            GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO: action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO && action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO,
                            productoCabalSeleccionadoDefault: action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO && action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO,
                            ParametrosGenerales: action.value.GET_ATLAS_PARAMETRO_GENERAL[0],
                            HabilitacionCajeros: action.value.GET_HABILITACION_CAJERO_PRODUCTO,

                            ParametrosGenerales: action.value.GET_ATLAS_PARAMETRO_GENERAL,
                            HabilitacionCajeros: action.value.GET_HABILITACION_CAJERO_PRODUCTO,
                            GET_PRODUCTO_VISA_PRODUCTO_ID: action.value.GET_PRODUCTO_VISA_PRODUCTO_ID,
                            GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID: action.value.GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID,
                            GET_LIMITE_COMPRA_PRODUCTO: action.value.GET_LIMITE_COMPRA_PRODUCTO,
                            GET_LINEA_PRESTAMO_PRODUCTO: action.value.GET_LINEA_PRESTAMO_PRODUCTO,
                            GET_PRODUCTO_DEFAULT_VISA_PRODUCTO: action.value.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO,
                            GET_ATLAS_PARAMETRO_GENERAL: action.value.GET_ATLAS_PARAMETRO_GENERAL[0] && action.value.GET_ATLAS_PARAMETRO_GENERAL[0],
                            GET_CARTERAS_EMPRESA: action.value.GET_CARTERAS_EMPRESA,
                            GET_CARTERAS_PRODUCTO: action.value.GET_CARTERAS_PRODUCTO,
                            GET_MODELO_LIQUIDACION_PRODUCTO: action.value.GET_MODELO_LIQUIDACION_PRODUCTO,
                            GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO: action.value.GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO,
                            GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID: action.value.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID,
                            GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID: action.value.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID,
                            GET_SUCURSAL_CLIENTE_CUENTA: action.value.GET_SUCURSAL_CLIENTE_CUENTA,
                            GET_HABILITACION_CAJERO_PRODUCTO: action.value.GET_HABILITACION_CAJERO_PRODUCTO,
                            GET_ATLAS_ENTIDAD_BANCARIA: action.value.GET_ATLAS_ENTIDAD_BANCARIA,
                            GET_ATLAS_MONEDA: action.value.GET_ATLAS_MONEDA,
                            GET_ATLAS_TIPO_CUENTA_BANCARIA: action.value.GET_ATLAS_TIPO_CUENTA_BANCARIA,
                            GET_TARJETA_TIPO_BY_CUENTA_TIPO: action.value.GET_TARJETA_TIPO_BY_CUENTA_TIPO,
                            GET_ATLAS_LIMITE_COMPRA: action.value.GET_ATLAS_LIMITE_COMPRA,
                            ATLAS_COMERCIALIZADORA: action.value.ATLAS_COMERCIALIZADORA,
                            productoId: action.value.productoId,

                            factorLimiteCompra: action.value.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO && action.value.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO.FLCCDefault,
                            limiteFinanciacion: action.value.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO && action.value.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO.LimiteFinanciacionDefault,

                            CLCC: action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO ? action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO.CLCCDefault : "0",
                            limiteCompra: action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO ? action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO.LimiteCompraDefault : "0",
                            topePagoMinimo: action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO ? action.value.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO.TopePagoMinimoDefault : "0"
                        }
                    }
                    break;
                case "cargaDatosPantallaAdicionales":

                    resultado = {
                        ...state,
                        solicitudCuenta: {
                            ...state.solicitudCuenta,
                            ATLAS_DISTRIBUCION: action.value.GET_CODIGO_DISTRIBUCION_BY_PRODUCTO_ID,
                            PRODUCTO_VISA: action.value.PRODUCTO_VISA,
                            cuentasAdicionales: Array.isArray(state.solicitudCuenta.cuentasAdicionales) ? state.solicitudCuenta.cuentasAdicionales : [],
                            ATLAS_GRUPO_AFINIDAD: action.value.ATLAS_GRUPO_AFINIDAD,
                            GET_CARTERAS_EMPRESA: action.value.carteras,
                            //ATLAS_SUCURSALES: action.value.ATLAS_SUCURSALES,
                        }
                    }
                    break;
                case "getScreenNSC":
                    resultado = {
                        ...state,
                        solicitudCuenta: {
                            ...state.solicitudCuenta,
                            ATLAS_SUCURSALES: action.value.ATLAS_SUCURSALES,
                            ATLAS_TIPO_COMUNICACION: action.value.ATLAS_TIPO_COMUNICACION,
                            ERROR_CUENTA: action.value.ERROR_CUENTA,
                            TELEFONOS_CLIENTE: action.value.TELEFONOS_CLIENTE,
                            CELULARES_CLIENTE: action.value.CELULARES_CLIENTE,
                            DOMICILIOS_CLIENTE: action.value.DOMICILIOS_CLIENTE,
                            SUCURSALES_CUENTAS_PESOS: action.value.SUCURSALES_CUENTAS_PESOS,
                            SUCURSALES_CUENTAS_DOLARES: action.value.SUCURSALES_CUENTAS_DOLARES,
                            clienteTarjeta: null
                        },
                        clienteResultadoBusqueda: {
                            ...state.clienteResultadoBusqueda,
                            clienteListaDocumentos: action.value.cuentasFinal
                        }
                    }
                    break;
                case "correspondencia":
                    resultado = {
                        ...state,
                        solicitudCuenta: {
                            ...state.solicitudCuenta,
                            comDomicilioPostal: action.value == "domicilioPostal",
                            comEmail: action.value == "email"
                        }
                    }
                    break;
                default:
                    resultado = {
                        ...state,
                        solicitudCuenta: {
                            ...state.solicitudCuenta,
                            [action.prop]: action.value
                        }
                    }
                    break;
            }

            ;
            break;

        case RESET_SELECCIONES_CUENTA:
            if (!state.esModificacion) {
                resultado = {
                    ...state,
                    solicitudCuenta: {}
                };
            }
            break;

        case CARGAR_DATOS_MODIFICACION_TARJETAS: {
            resultado = {
                ...state,
                solicitudCuenta: {
                    ...state.solicitudCuenta,
                    [action.seccionCargada]: true
                }
            }
            break;
        }

        case LOAD_MODIFICACION_SOLICITUD_TARJETAS:

            resultado = {
                ...state,
                esModificacion: true,
                administradora: action.payload.administradora,
                tipoEmpresa: action.payload.tipoEmpresa,
                datosSolicitud: action.payload.datosSolicitud,
                cuentasAdicionales: action.payload.datosSolicitud.tarjetasMapeadas.filter(tarjeta => !tarjeta.EsTitular),
                empresas: action.payload.empresaNueva ? [...state.empresas, action.payload.empresaNueva] : state.empresas,
                empresaVisaSeleccionada: action.payload.empresaNueva ? action.payload.empresaNueva : action.payload.empresaSeleccionada ? action.payload.empresaSeleccionada : null
            };
            break;

        case CARGAR_ADICIONALES_MODIFICACION: {

            resultado = {
                ...state,
                solicitudCuenta: {
                    ...state.solicitudCuenta,
                    cuentasAdicionales: action.payload
                }
            }
            break;
        }
        case RESET_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE:

            resultado = {
                ...state,
                solicitudCuenta: null,
                esModificacion: false,
                tipoEmpresa: {},
                administradora: {},
                empresaVisaSeleccionada: null,
                clienteTarjeta: null,
                esCuentaExistente: false,
                cuentasAdicionales: null,
                errorWSClienteAdicional: null,
                datosSolicitud: null,
                adicionalesEliminados: []
            };
            break;

        case ACTUALIZAR_ESTADO_GLOBAL_EMPRESA:

            resultado = {
                ...state,
                empresas: action.empresas
            };
            break;

        case ACTUALIZAR_ESTADO_DISTRIBUCION_EMPRESA:

            resultado = {
                ...state,
                seleccionDistribucionLimite: 0
            };
            break;

        case ACTUALIZAR_ESTADO_DISTRIBUCION_CUENTA:

            resultado = {
                ...state,
                seleccionDistribucionLimite: 1
            };
            break;

        case ACTUALIZAR_ESTADO_DISTRIBUCION_TARJETA:

            resultado = {
                ...state,
                seleccionDistribucionLimite: 2
            };
            break;

        case ACTUALIZAR_ESTADO_GLOBAL_CUENTA:

            //Se mantienen las rows seleccionadas en el array de cuentas del wizard
            cuentasTemp = JSON.parse(JSON.stringify(state.cuentas));
            let cuentaSeleccionada = action.cuentas.find((cuenta) => cuenta.seleccionada == true);

            if (cuentaSeleccionada) {
                cuentasTemp.forEach((cuenta) => {
                    if (cuentaSeleccionada.Id == cuenta.Id) {
                        cuenta.seleccionada = true;
                    }
                });
            }

            resultado = {
                ...state,
                cuentas: cuentasTemp
            };

            break;

        case ACTUALIZAR_ESTADO_GLOBAL_CUENTA_SELECCIONADA:

            //Se mantienen las rows seleccionadas en el array de cuentas del wizard
            cuentasTemp = JSON.parse(JSON.stringify(state.cuentas));

            cuentasTemp.forEach(function (cuenta) {
                cuenta.seleccionada = (cuenta.Id == action.id);
            })

            resultado = {
                ...state,
                cuentas: cuentasTemp
            };

            break;

        case ACTUALIZAR_ESTADO_GLOBAL_NUEVA_CUENTA:

            cuentasTemp = JSON.parse(JSON.stringify(state.cuentas));
            let cuentaIndice = -1;

            cuentasTemp.forEach((cuenta, index) => {
                if (cuenta.Id == action.cuenta.Id) {
                    cuentaIndice = index;
                }

                if (cuenta.Id != action.cuenta.Id) {
                    cuenta.seleccionada = false;
                }
                else {
                    cuenta.seleccionada = true;
                }
            });

            if (cuentaIndice >= 0) {
                cuentasTemp.splice(cuentaIndice, 1);
            }

            if (!action.cuenta.esNueva) {
                action.cuenta.editada = true;
            }
            cuentasTemp.push(action.cuenta);
            cuentasTemp.sort(x => x.Id);
            return {
                ...state,
                cuentas: cuentasTemp
            }

        case ACTUALIZAR_ESTADO_GLOBAL_TARJETA:

            resultado = {
                ...state,
                tarjetas: action.tarjetas
            };
            break;

        case ACTUALIZAR_DATOS_INICIO_NUEVA_SOLICITUD:

            resultado = {
                ...state,
                esModificacion: false,
                estadoSolicitud: undefined,
                borradorId: undefined
            };
            break;

        case GUARDAR_DISTRIBUCION_LIMITES:

            resultado = {
                ...state,
                empresas: action.resultadoDistribucionLimites.empresas,
                cuentas: action.resultadoDistribucionLimites.cuentas,
                tarjetas: action.resultadoDistribucionLimites.tarjetas,
                novedadesEmpresas: action.resultadoDistribucionLimites.novedadesEmpresas,
                novedadesCuentas: action.resultadoDistribucionLimites.novedadesCuentas,
                novedadesTarjetas: action.resultadoDistribucionLimites.novedadesTarjetas
            };
            break;

        //GUARDADO CLIENTES ADICIONALES EN TARJETAS
        case GUARDAR_SOLICITUD_CUENTA_ADICIONAL:
            //guarda las selecciones de un cliente adicional en el arreglo de clientes adicionales     
            if (action.nuevaSolicitudAdicional.idAdicional == 0) {//si se cumple, esta agregando un nuevo adicional
                resultado = {
                    ...state,
                    solicitudCuenta: {
                        ...state.solicitudCuenta,
                        cuentasAdicionales: [...state.solicitudCuenta.cuentasAdicionales, action.value]
                    }
                }
            } else {//si no se cumple esta editando un cliente adicional ya existente
                let newArr = []
                state.solicitudCuenta.cuentasAdicionales.map(function (adicional) {
                    if (adicional.idAdicional == action.nuevaSolicitudAdicional.idAdicional) {
                        /* const adicionalEditado = {
                             Apellido: action.value.Apellido,
                             IdAdicional: action.nuevaSolicitudAdicional.idAdicional,
                             CodigoDistribucionId: action.value.CodigoDistribucionId,
                             CuotasEmision: action.value.CuotasEmision,
                             HabilitacionCajeroId: action.value.HabilitacionCajeroId,
                             LimiteDeAdelantos: action.value.LimiteDeAdelantos,
                             LimiteDeCEC: action.value.LimiteDeCEC,
                             LimiteDeCompra: action.value.LimiteDeCompra,
                             Nombre: action.value.Nombre,
                             PorcentajeEmision: action.value.PorcentajeEmision,
                             idAdicional: action.nuevaSolicitudAdicional.idAdicional,
                             denominacionCuartaLinea: action.value.denominacionCuartaLinea,
                             usoCajerosConCargo:action.value.usoCajerosConCargo,
                             codigoAreaCentroDeCostos: action.value.codigoAreaCentroDeCostos,
                             codigoSectorCentroDeCostos:action.value.codigoSectorCentroDeCostos,
                             vigenciaTemporalId:action.value.vigenciaTemporalId
                         }*/
                        let adicionalEditado = JSON.parse(JSON.stringify(action.value))
                        newArr.push(adicionalEditado)
                    } else {
                        newArr.push(adicional)
                    }
                });
                resultado = {
                    ...state,
                    solicitudCuenta: {
                        ...state.solicitudCuenta,
                        cuentasAdicionales: newArr

                    }
                }
            }
            break;
        case ELIMINAR_CLIENTE_ADICIONAL:
            let newArr = []
            state.solicitudCuenta.cuentasAdicionales.map(function (adicional) {
                if (adicional.idAdicional != action.id) {
                    newArr.push(adicional)
                }
            })
            resultado = {
                ...state,
                solicitudCuenta: {
                    ...state.solicitudCuenta,
                    cuentasAdicionales: newArr

                }
            }
            break;

        case VOLVER_A_SOLICITUD:

            resultado = {
                ...state,
                vuelveDeAdicional: action.payload,
                clienteTarjeta: null
            }

            break;
        case VOLVER_A_SOLICITUD_NSC:

            resultado = {
                ...state,
                vuelveDeAdicional: false
            }

            break;

        case ELIMINAR_FUTURO_FROM_TIPO_EMPRESA:

            empresasTemp = JSON.parse(JSON.stringify(state.empresas));
            cuentasTemp = JSON.parse(JSON.stringify(state.cuentas));
            tarjetasTemp = JSON.parse(JSON.stringify(state.tarjetas));

            //Elimino las rows nuevas.
            empresasTemp = empresasTemp.filter(x => x.esNueva == false);
            cuentasTemp = cuentasTemp.filter(x => x.esNueva == false);
            tarjetasTemp = tarjetasTemp.filter(x => x.esNueva == false);

            //Pongo las rows seleccionadas en false.
            if (empresasTemp != undefined)
                empresasTemp.forEach(function (item) { item.seleccionada = false });

            if (cuentasTemp != undefined)
                cuentasTemp.forEach(function (item) { item.seleccionada = false });

            if (tarjetasTemp != undefined)
                tarjetasTemp.forEach(function (item) { item.seleccionada = false });

            resultado = {
                ...state,
                empresas: empresasTemp,
                cuentas: cuentasTemp,
                tarjetas: tarjetasTemp
            };
            break;

        case ELIMINAR_FUTURO_FROM_EMPRESA:

            cuentasTemp = JSON.parse(JSON.stringify(state.cuentas));
            tarjetasTemp = JSON.parse(JSON.stringify(state.tarjetas));

            //Elimino las rows nuevas.
            cuentasTemp = cuentasTemp.filter(x => x.esNueva == false);
            tarjetasTemp = tarjetasTemp.filter(x => x.esNueva == false);

            //Pongo las rows seleccionadas en false.
            if (cuentasTemp != undefined)
                cuentasTemp.forEach(function (item) { item.seleccionada = false });

            if (tarjetasTemp != undefined)
                tarjetasTemp.forEach(function (item) { item.seleccionada = false });

            resultado = {
                ...state,
                cuentas: cuentasTemp,
                tarjetas: tarjetasTemp
            };
            break;

        case ELIMINAR_FUTURO_FROM_CUENTA:

            tarjetasTemp = JSON.parse(JSON.stringify(state.tarjetas));

            //Elimino las rows nuevas.
            tarjetasTemp = tarjetasTemp.filter(x => x.esNueva == false);

            //Pongo las rows seleccionadas en false.
            if (tarjetasTemp != undefined)
                tarjetasTemp.forEach(function (item) { item.seleccionada = false });

            resultado = {
                ...state,
                tarjetas: tarjetasTemp
            };
            break;
        case EMPRESA_SELECCIONADA:

            resultado = {
                ...state,
                empresaVisaSeleccionada: action.payload
            };
            break;

        //DELIVERY...
        case WEBSERVICE_RESULT:
            resultado = {
                ...state,
                dataUsuario: action.cliente !== undefined ? action.cliente : undefined
            };
            break;

        case CARGAR_TARJETAS_BY_CUENTA:
            action.limites.unshift({ Id: 0, LimiteDescripcion: 'Seleccione...' });
            resultado = {
                ...state,
                tarjetas: action.result.tarjetasByNroCliente,
                solicitudes: action.result.solicitudesByNroCliente,
                consultaCuenta: action.result.consultaCuenta,
                limites: action.limites,
                erroresLink: action.erroresLink,
                estadosIbs: action.estadosIbs,
                sucursalUsuarioId: action.result.sucursalUsuarioId[0] !== undefined ? action.result.sucursalUsuarioId[0].Id : -1
            };
            break;

        case ADD_TARJETA_NUEVA_SOLICITUD:
            let tarjetas = state.tarjetas;
            let tarjeta = action.tarjeta;
            tarjeta.Numero = '-----------------------';
            tarjetas.push(action.tarjeta)
            resultado = {
                ...state,
                tarjetas: tarjetas
            };
            break;

        case REMOVE_TARJETA_NUEVA_SOLICITUD:
            let index = state.tarjetas.findIndex(x => x.key == action.idTarjeta)
            state.tarjetas.splice(index, 1);
            resultado = {
                ...state
            };
            break;

        case BORRAR_SOLICITUD_PENDIENTE_CUENTAS:
            let _solicitudes = state.solicitudes;

            for (var i = 0; i < _solicitudes.length; i++) {
                if (_solicitudes.find(x => x.col0 == action.idSolicitud) !== undefined) {
                    _solicitudes.splice(i, 1);
                }
            }

            resultado = {
                ...state
            };
            break;

        case OBTENER_DOMICILIOS_SELECCIONAR_CUENTA:
            action.domicilios.unshift({ LOCALIDAD: -1, Descripcion: 'Seleccione...' });
            resultado = {
                ...state,
                domicilios: action.domicilios,
                plasticosSolicitudes: action.plasticosSolicitudes
            };
            break;

        case SET_CUENTA_DELIVERY:
            resultado = {
                ...state,
                cuentasDelivery: action.cuentas,
                sucursalesDelivery: action.sucursales
            };
            break;

        //FIN DELIVERY...

        case GET_INITIAL_DATA_TARJETAS_SUCCESS:

            let menuUsuario = action.result.GET_MENU_BY_USUARIO_ID;
            let path = action.result.GET_USUARIO_INICIO[0] ? true : false;
            let productosCount = action.result.GET_PRODUCTO_USUARIO_LOGIN.length;

            let initialProduct = action.result.GET_PRODUCTO_USUARIO_LOGIN[0].ProductoId;
            let rowsPerProduct = action.result.GET_PRODUCTO_USUARIO_LOGIN.filter(
                x => x.ProductoId != initialProduct
            );

            resultado = {
                ...state,
                programSelected: path,
                productos: productosCount,
                defaultProducto: rowsPerProduct.length == 0 ? action.result.GET_PRODUCTO_USUARIO_LOGIN[0] : null,
            };
            break;

        case SELECCIONAR_COMPONENTE:
            resultado = {
                ...state,
                componenteVistaCliente: action.componenteId
            };
            break;
        case ELIMINAR_CLIENTE_ADICIONAL_TARJETAS:
            resultado = {
                ...state,
                adicionalesEliminados: [...state.adicionalesEliminados, action.adicionalEliminado]
            };
            break;
        case GET_SCREEN_DATA_CLIENTE:

            resultado = {
                ...state,
                Cliente: action.ClienteActualizado
            };
            break;
        case SET_DATA_CLIENTE:

            resultado = {
                ...state,
                Cliente: action.cliente
            };
            break;

        case ROUTE_TO_CUENTA_CLIENTE:
            resultado = {
                ...state,
                redirectToCuentaCliente: action.bool,
                cuentaCorriente: action.cuenta
            };
            break;

        case RESET_STATE_VISTA_CLIENTE: {
            resultado = {
                ...state,
                redirectToCuentaCliente: action.bool
            };
        } break;
        case SET_CLAIMS:
            resultado = {
                ...state,
                claims: action.claims
            };
            break;
        default:
            resultado = {
                ...state
            };
            break;
    }

    LogHelper.Out(tarjetas.name, resultado);
    return resultado;
}

export default tarjetas;